export interface FoodItem {
  key: string;
  name: string;
  emoji: string;
  description: string;
  xpRequired: number;
  tokenCost: number;
  effects: {
    happiness: number;
    hunger: number;
    energy?: number;
  };
  portions: number;
}

export const FOOD_ITEMS: Record<string, FoodItem> = {
  basic_seed: {
    key: 'basic_seed',
    name: 'Basic Seed',
    emoji: '🌱',
    description: 'A simple seed that provides basic nutrition',
    xpRequired: 0,
    tokenCost: 0, // Free starter food
    effects: {
      happiness: 10,
      hunger: 20,
    },
    portions: 1,
  },
  premium_berry: {
    key: 'premium_berry',
    name: 'Premium Berry',
    emoji: '🍓',
    description: 'A delicious berry that boosts mood and energy',
    xpRequired: 50,
    tokenCost: 5,
    effects: {
      happiness: 20,
      hunger: 30,
      energy: 5,
    },
    portions: 1,
  },
  energy_nectar: {
    key: 'energy_nectar',
    name: 'Energy Nectar',
    emoji: '🍯',
    description: 'Special nectar that provides sustained energy',
    xpRequired: 100,
    tokenCost: 10,
    effects: {
      happiness: 25,
      hunger: 25,
      energy: 15,
    },
    portions: 1,
  },
};

export type FoodKey = keyof typeof FOOD_ITEMS;